import { AssetLocation } from './asset-location.model';
import { ChargeType } from './charge-type.model';
import { EstimateFunction } from './estimate-function.model';
import { RetirementUnit } from './retirement-unit.model';
import { UnitReminder } from './unit-reminder.model';
import { UtilityAccount } from './utility-account.model';

export class ProjectEstimate {
  constructor(
    projectFunction?: EstimateFunction,
    utilityAccount?: UtilityAccount,
    retirementUnit?: RetirementUnit,
    chargeType?: ChargeType,
    quantity?: number,
    assetLocation?: AssetLocation,
    estimatedCosts?: number,
    utilityAccountOptions?: UtilityAccount[],
    retirementUnitOptions?: RetirementUnit[],
    unitReminder?: UnitReminder
  ) {
    this.projectFunction = projectFunction;
    this.utilityAccount = utilityAccount;
    this.retirementUnit = retirementUnit;
    this.chargeType = chargeType;
    this.quantity = quantity;
    this.assetLocation = assetLocation;
    this.estimatedCosts = estimatedCosts;
    this.utilityAccountOptions = utilityAccountOptions;
    this.retirementUnitOptions = retirementUnitOptions;
    this.unitReminder = unitReminder;
  }

  projectFunction: EstimateFunction;
  utilityAccount: UtilityAccount;
  retirementUnit: RetirementUnit;
  chargeType: ChargeType;
  quantity: number;
  assetLocation: AssetLocation;
  estimatedCosts: number;
  utilityAccountOptions: UtilityAccount[];
  retirementUnitOptions: RetirementUnit[];
  unitReminder: UnitReminder;
}
